import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "icon" }
const _hoisted_2 = {
  key: 0,
  class: "user-info"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = {
  key: 0,
  class: "user-info"
}

import { isExpand } from "@/views/Home/useData/useHomePage";
import UserMenu from "@/views/Home/components/UserMenu.vue";
import { openLoginDialog } from "@/components/Dialogues/useData/login";
import { ref } from "vue";
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserInfoBar',
  setup(__props) {

const { isLogin, userInfo } = storeToRefs(publicStore());

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_unref(isLogin))
    ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        placement: "top",
        width: 200,
        trigger: "click",
        "show-arrow": false,
        style: { '--el-popover-border-radius': 14 }
      }, {
        reference: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["bar", { close: !_unref(isExpand) }])
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_unref(userInfo).avatar)
                ? (_openBlock(), _createBlock(_component_el_image, {
                    key: 0,
                    style: {"width":"34px","height":"34px"},
                    src: _unref(userInfo).avatar,
                    fit: "cover"
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock(_component_el_icon, {
                    key: 1,
                    size: 26
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserFilled)
                    ]),
                    _: 1
                  }))
            ]),
            (_unref(isExpand))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "个人信息"))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        default: _withCtx(() => [
          _createVNode(UserMenu)
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["bar", { close: !_unref(isExpand) }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openLoginDialog) && _unref(openLoginDialog)(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_icon, { size: 26 }, {
              default: _withCtx(() => [
                _createVNode(_component_UserFilled)
              ]),
              _: 1
            })
          ]),
          (_unref(isExpand))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "点击登录"))
            : _createCommentVNode("", true)
        ], 2)
      ]))
}
}

})